import React from 'react';
import cx from 'classnames';

import Input from './input';

class EditFieldModal extends React.Component {
  /**
   * A reusable modal with an input field.
   *
   * @param {object} props
   * @param {string} props.id - Id of the modal confirmation div, will be 'modal-confirmation-{{PROVIDED_ID}}'
   * @param {string} props.title - Title of the modal
   * @param {string} props.label - Label for the input
   * @param {string} props.value - Initial value for the input
   * @param {string} props.putUrl - Where are going to send this thing?
   * @param {string} props.paramName - name of the param to send up the chain
   * @param {string} props.owningEntityParam - Param for the object that we're updating with this input
   * @param {string} props.placeholder - placeholder text for the input
   * @param {string} props.submit_text - the text used as the submit button text
   */

  constructor(props) {
    super(props);
    this.state = { inputValue: props.value || null };
  }

  setInputValue = e => {
    this.setState({ inputValue: e.target.value });
  };

  submitInput = () => {
    if (this.state.inputValue != null) {
      const { owningEntityParam, paramName, putUrl } = this.props;
      let params = { id: owningEntityParam };
      params[paramName] = this.state.inputValue;

      $.ajax({
        type: 'PUT',
        url: putUrl,
        data: params,
        success: (data, textStatus, xhr) => {
          window.location.reload(true);
        },
        error: (xhr, textStatus) => {
          HRB.utils.basicFailAndReload('saving a field');
        },
      });
    } else {
      alert('This field cannot be blank!');
    }
  };

  onCancel = () => {
    const { id, onCancel } = this.props;
    $(document).trigger(`statuspage.confirm.${id}.canceled`);
    if (onCancel) {
      onCancel();
    }
  };

  render() {
    const {
      className,
      id,
      title,
      label,
      paramName,
      placeholder,
      submit_text,
    } = this.props;
    let containerClasses = cx('modal hide fade modal-confirmation', className);

    return (
      <div
        className={containerClasses}
        id={`modal-confirmation-${id}`}
        style={{ display: 'none' }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <a href="#" data-dismiss="modal" className="close close-adg3-hide">
              ×
            </a>
            <h4>{title}</h4>
          </div>
          <div className="modal-body">
            <Input
              type="text"
              label={label}
              inputClass="full-width"
              name={paramName}
              placeholder={placeholder}
              value={this.state.inputValue}
              onChange={this.setInputValue}
            />
          </div>
          <div className="modal-footer modal-footer-reverse">
            <button
              className="cpt-button style-primary"
              data-dismiss="modal"
              id={`btn-confirm-${id}`}
              onClick={this.submitInput}
            >
              {submit_text}
            </button>
            <a
              href="#"
              id={`btn-cancel-${id}`}
              data-dismiss="modal"
              className="close"
              onClick={this.onCancel}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default EditFieldModal;
